import { useMemo } from 'react';
import { Row, Tag, Col } from 'antd';
import type { FormItemType, ColumnType } from 'xui-pro';
import type { Part } from '@/api/epc/catalog/usageUsingPOST';
import type { SubstituteItem, PartInfo } from '@/api/epc/part/partSubstituteUsingPOST';
import EllipsisText from '@/components/EllipsisText';

import styles from './index.module.less';
const PHOTOTYPE = {
  1: '左',
  2: '右',
  3: '钢印',
  4: '前',
  5: '后',
  6: '其他'
};
const useFormItems = () => {
  const formItems = useMemo(() => {
    return [
      {
        label: '备件编码',
        name: 'partNo'
      },
      {
        label: '状态',
        name: 'saleState',
        render: ({ value }) => {
          return !value ? '停售' : '正常';
        }
      },
      {
        label: '备件名称',
        name: 'partName'
      },
      {
        label: '参考数量',
        name: 'qty',
        render: ({ value }) => (value ? `${value}` : '-')
      },
      {
        label: '创建时间',
        name: 'createTime'
      },
      {
        label: '用法备注',
        name: 'note',
        render: ({ value }) =>
          value ? <EllipsisText text={value} lineClamp={3} placement='rightTop' /> : '-'
      }
    ] as FormItemType<Part>[];
  }, []);

  return formItems;
};

const PartComponent = (list: PartInfo[], handlePartSearch, isInIframe) => {
  return (
    <>
      {list?.map(item => {
        const { partNo, partName, priceDisplay, salePrice, saleState } = item;
        const showPrice = !!(priceDisplay && salePrice && saleState);
        return (
          <Row className={styles.partRow} align='middle'>
            {isInIframe && (
              <Col span={4}>
                <div
                  className={showPrice ? styles.addIcon : styles.unableAddIcon}
                  onClick={() => {
                    if (showPrice)
                      window.parent?.postMessage(
                        {
                          action: 'afs.addPartFromEPC',
                          payload: { partCode: partNo }
                        },
                        '*'
                      );
                  }}
                />
              </Col>
            )}
            <Col span={isInIframe ? 20 : 24}>
              <div className={styles.partItem}>
                <div className={styles.partMain}>
                  {partNo && (
                    <EllipsisText
                      text={partNo}
                      className={styles.partNo}
                      onClick={() => {
                        handlePartSearch(partNo);
                      }}
                    />
                  )}
                  <div className={styles.partInfo}>
                    {!saleState && (
                      <Tag color='error' style={{ marginRight: 4 }}>
                        停售
                      </Tag>
                    )}
                    {partName && <EllipsisText text={`${partName}`} className={styles.partName} />}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

const useColumns = (handlePartSearch, isInIframe) => {
  const columns = useMemo(() => {
    return [
      {
        title: '备件编码',
        dataIndex: 'oldList',
        className: styles.partNoCell,
        width: isInIframe ? 230 : 200,
        render: (_, row) => {
          const { oldList } = row as SubstituteItem;
          return PartComponent(oldList as PartInfo[], handlePartSearch, isInIframe);
        }
      },
      {
        title: '替换件编码',
        dataIndex: 'newList',
        className: styles.partNoCell,
        width: isInIframe ? 230 : 200,
        render: (_, row) => {
          const { newList } = row as SubstituteItem;
          return PartComponent(newList as PartInfo[], handlePartSearch, isInIframe);
        }
      },

      {
        title: '替换类型',
        dataIndex: 'substituteTypeName'
      },
      {
        title: '替换备注',
        dataIndex: 'note'
      }
    ] as ColumnType[];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInIframe]);

  return columns;
};

export { useFormItems, useColumns, PHOTOTYPE };
